import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { selectService } from '../../../actions/actionCreators'
import Location from '../Location'

const mapStateToProps = (state) => ({ ...state })

/**
 * This Component will extract the service code from url.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FirstPage = (props) => {
	const { match: { params: { service } = {} } = {} } = props

	useEffect(() => {
		selectService(Number(service))
	}, [service])

	return <Location />
	// return <SimpleMap />;
}

export default withRouter(connect(mapStateToProps)(FirstPage))
